import { toast } from "react-toastify";
import { TOAST_MESSAGES, ToastKey } from "../../constants/toastMessages";

export const showToast = {
  success: (key: ToastKey) => toast.success(TOAST_MESSAGES[key]),
  warn: (key: ToastKey) => toast.warn(TOAST_MESSAGES[key]),
  error: (key: ToastKey) => toast.error(TOAST_MESSAGES[key]),
  info: (key: ToastKey) => toast.info(TOAST_MESSAGES[key]),
};
